import React from "react";
import Licon from "./assets/Images/linkedin.png";
import Ficon from "./assets/Images/facebook.png";
import { useTranslation } from "react-i18next";
import "./Footer.scss";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="footer">
        <p>
          {new Date().getFullYear()} &copy; HKAS. {t("footer_text")}
        </p>
        <div className="flex">
          <a href="https://www.linkedin.com/in/hong-kong-arbitration-society-382458139">
            <img src={Licon} alt="" />
          </a>
          <a href="https://www.facebook.com/%E9%A6%99%E6%B8%AF%E4%BB%B2%E8%A3%81%E5%85%AC%E6%9C%83-HKAS-1056310707772389/?ref=page_internal">
            <img src={Ficon} alt="" />
          </a>
        </div>
      </div>
    </>
  );
};

export default Footer;
